<div class="container" id="print-section">

  <table style="width:100%;border:2px solid #000;border-collapse:collapse;text-align:center;">

    <!-- HEADER -->
    <tr>
      <td colspan="5" style="border:2px solid #000;font-weight:bold;font-size:20px;">
      विवेक पुस्तक प्रकाशन
    </td>
      <td colspan="5" style="border:2px solid #000;font-size:18px;font-weight:bold;padding:6px;">
         पुस्तक छपाई आदेश
      </td>
    </tr>

    <!-- DATE + BOOK -->
    <tr>
      <td colspan="5" style="border:2px solid #000;padding:6px;">
        दिनांक : {{ adesh_date | date:'dd-MM-yyyy' }}
      </td>

      <td colspan="4" style="border:2px solid #000;font-weight:bold;padding:6px;">
        {{ book_name }}
      </td>
    </tr>

    <!-- TOTAL -->
    <tr>
      <td colspan="5" style="border:2px solid #000;text-align:left;padding:6px;">
        एकूण प्रती : <strong>{{ totalprati }}</strong>
      </td>

      <td colspan="4" style="border:2px solid #000;text-align:right;padding:6px;">
        एकूण पृष्ठ : <strong>{{ totalpsankhya }}</strong>
      </td>
    </tr>

    <!-- HEADER ROW -->
    <tr style="background:#f2f2f2;">
      <td style="border:2px solid #000;">क्रमांक</td>
      <td colspan="3" style="border:2px solid #000;">विगत</td>
      <td colspan="2" style="border:2px solid #000;">प्रती</td>
      <!-- <td colspan="4" style="border:2px solid #000;">शेरा</td> -->
    </tr>

    <!-- DATA -->
    <tr *ngFor="let item of tempdata">
      <td style="border:2px solid #000;padding:6px;">{{ item.no }}</td>

      <td colspan="3" style="border:2px solid #000;text-align:left;">
        {{ item.name }}
      </td>

      <td colspan="2" style="border:2px solid #000;">
        {{ item.prati }}
      </td>

      <!-- <td colspan="4" style="border:2px solid #000;text-align:left;">
        {{ item.shera }}
      </td> -->
    </tr>

    <!-- EMPTY -->
    <tr *ngIf="tempdata.length === 0">
      <td colspan="10" style="padding:10px;color:#999;">
        No Data Found
      </td>
    </tr>

    <!-- TOTAL FOOTER -->
    <tr style="background:#f2f2f2;">
      <td colspan="4" style="border:2px solid #000;font-weight:bold;">
        एकूण
      </td>
      <td colspan="2" style="border:2px solid #000;font-weight:bold;">
        {{ totalprati }}
      </td>
      <!-- <td colspan="4" style="border:2px solid #000;"></td> -->
    </tr>

  </table>
</div>

<!-- BUTTONS -->
<div style="display:flex;justify-content:flex-end;gap:10px;margin-top:10px;">

  <button mat-raised-button color="primary"
          printSectionId="print-section"
          ngxPrint>
    Print
  </button>

  <button mat-raised-button color="warn" (click)="closeDialog()">
    Close
  </button>

</div>
